import request from './request';
import config from './config';

export default {
	// 2023-12-09
	// 分类列表
	categoryList: (params) => {
		return request.get(config.api.apiUrl + '/category_list', params);
	},
	// 推荐分类
	recommendCateGoryList: (params) => {
		return request.get(config.api.apiUrl + '/recommend_category_list', params);
	},
	// 首页推荐商品
	indexGoodsList: (params) => {
		return request.get(config.api.apiUrl + '/index_goos_list', params);
	},
	// 专题下商品
	channelProducts: (params) => {
		return request.get(config.api.apiUrl + '/channel_products', params);
	},
	// 专题下商品
	getOrderDetail: (params) => {
		return request.get(config.api.apiUrl + '/get_verification_order', params);
	},

	// 推荐专题
	recommendProject: (params) => {
		return request.get(config.api.apiUrl + '/recommend_project', params);
	},
	// 分类下面的商品
	catogoryProducts: (params) => {
		return request.get(config.api.apiUrl + '/catogory_products', params);
	},
	// 所有专题
	projectList: (params) => {
		return request.get(config.api.apiUrl + '/project_list', params);
	},
	// 企业介绍
	getEnterpriseZIntroduce: (params) => {
		return request.get(config.api.apiUrl + '/get_enterprise_introduce', params);
	},
	// 搜索商品
	searchProducts: (params) => {
		return request.get(config.api.apiUrl + '/search_products', params);
	},
	// 行业分类
	shopCategory: (params) => {
		return request.get(config.api.apiUrl + '/get_shop_category', params);
	},
	// 商家列表
	getShopList: (params) => {
		return request.get(config.api.apiUrl + '/recommend_shop_list', params);
	},
	// 商家列表
	getShopLists: (params) => {
		return request.get(config.api.apiUrl + '/shop_category_list', params);
	},
	// 通过核销码获取订单
	getVerificationOrder: (params) => {
		return request.get(config.api.apiUrl + '/get_verification_order', params);
	},
	// 核销订单
	verificationOrder: (params) => {
		return request.post(config.api.apiUrl + '/verification_order', params);
	},

	// 注册
	register: (params) => {
		return request.post(config.api.apiUrl + '/register', params, false);
	},
	// 登录
	login: (params) => {
		return request.post(config.api.apiUrl + '/login', params, false);
	},
	// 首页套餐列表
	getSuitList: (params) => {
		return request.post(config.api.apiUrl + '/get_suit_list', params, false);
	},
	// 获取会员升级详情
	getUpgradeSetMeal: (params) => {
		return request.post(config.api.apiUrl + '/get_upgrade_set_meal', params);
	},
	// 订单详情
	orderDetail: (params) => {
		return request.post(config.api.apiUrl + '/order_detail', params);
	},
	// 会员升级下单
	buyUpgrade: (params) => {
		return request.post(config.api.apiUrl + '/buy_upgrade', params);
	},
	// 现金券明细
	getCashCouponLog: (params) => {
		return request.post(config.api.apiUrl + '/get_cash_coupon_log', params);
	},
	// 首页轮播图
	getAdList: (params) => {
		return request.post(config.api.apiUrl + '/get_ad_list', params, false);
	},
	// 兑换商品列表
	getExchangeList: (params) => {
		return request.post(config.api.apiUrl + '/get_exchange_list', params, false);
	},
	// 兑换商品详情
	goodsDetails: (params) => {
		return request.post(config.api.apiUrl + '/goods_details', params, false);
	},
	// 积分详情
	getIntegralList: (params) => {
		return request.post(config.api.apiUrl + '/get_integral_list', params);
	},
	// 转出现金券
	transferCashCoupon: (params) => {
		return request.post(config.api.apiUrl + '/transfer_cash_coupon', params);
	},
	// 计算积分价与数元价
	getPayPrice: (params) => {
		return request.post(config.api.apiUrl + '/get_pay_price', params);
	},
	// 兑换商品
	exchangeGoods: (params) => {
		return request.post(config.api.apiUrl + '/exchange_goods', params);
	},
	// 获取默认地址
	getDefaultAddress: (params) => {
		return request.post(config.api.apiUrl + '/get_default_address', params);
	},
	// 地址列表
	getAddressList: (params) => {
		return request.bgPost(config.api.apiUrl + '/get_address_list', params);
	},
	// 添加收获地址
	addAddress: (params) => {
		return request.post(config.api.apiUrl + '/add_address', params);
	},
	// 获取省市区
	getNotAgentArea: (params) => {
		return request.bgPost(config.api.apiUrl + '/get_not_agent_area', params);
	},
	// 删除地址
	deleteAddress: (params) => {
		return request.bgPost(config.api.apiUrl + '/delete_address', params);
	},
	// 地址详情
	addressDetail: (params) => {
		return request.post(config.api.apiUrl + '/address_detail', params);
	},
	// 订单详情
	orderList: (params) => {
		return request.post(config.api.apiUrl + '/order_list', params);
	},
	// 我的积分
	getIntegral: (params) => {
		return request.post(config.api.apiUrl + '/get_integral', params);
	},
	// 我的数元
	getMatheme: (params) => {
		return request.post(config.api.apiUrl + '/get_matheme', params);
	},
	// 数元明细
	getMathemeList: (params) => {
		return request.post(config.api.apiUrl + '/get_matheme_list', params);
	},
	// 数院界面
	getMathemeValue: (params) => {
		return request.post(config.api.apiUrl + '/get_wes_value', params);
	},
	// 在线客服
	getCustomerCode: (params) => {
		return request.post(config.api.apiUrl + '/get_customer_code', params);
	},
	// 用户信息
	getUserInfo: (params) => {
		return request.post(config.api.apiUrl + '/get_user_info', params);
	},
	// 积分可以兑换多少数元
	getIntegralExchangeValue: (params) => {
		return request.post(config.api.apiUrl + '/get_integral_exchange_value', params, false);
	},
	// 兑换数元界面
	integralExchangeData: (params) => {
		return request.post(config.api.apiUrl + '/integral_exchange_data', params);
	},
	// 兑换数元
	integralExchange: (params) => {
		return request.post(config.api.apiUrl + '/integral_exchange', params);
	},
	// 质押界面
	getPledgeData: (params) => {
		return request.post(config.api.apiUrl + '/get_pledge_data', params);
	},
	// 质押
	userPledge: (params) => {
		return request.post(config.api.apiUrl + '/user_pledge', params);
	},
	// 解押
	userRelease: (params) => {
		return request.post(config.api.apiUrl + '/user_release', params);
	},
	// 质押明细
	pledgeLog: (params) => {
		return request.post(config.api.apiUrl + '/pledge_log', params);
	},
	// 手机号获取用户昵称
	getNameByMobile: (params) => {
		return request.post(config.api.apiUrl + '/get_name_by_mobile', params);
	},
	// 获取手续费比例
	getServiceCharge: (params) => {
		return request.bgPost(config.api.apiUrl + '/get_service_charge', params, false);
	},
	// 互转数元
	userTransfer: (params) => {
		return request.post(config.api.apiUrl + '/user_transfer', params);
	},
	// 互转积分
	userTransferIntegral: (params) => {
		return request.post(config.api.apiUrl + '/user_transfer_integral', params);
	},
	// 团队列表
	userTeamList: (params) => {
		return request.post(config.api.apiUrl + '/user_team_list', params);
	},
	userTeamListBg: (params) => {
		return request.bgPost(config.api.apiUrl + '/user_team_list', params);
	},
	// 用户团队界面
	getUserTeam: (params) => {
		return request.bgPost(config.api.apiUrl + '/get_user_team', params);
	},
	// 团队收益明细
	getProfitList: (params) => {
		return request.post(config.api.apiUrl + '/get_profit_list', params);
	},
	// 互转明细
	getTransferList: (params) => {
		return request.post(config.api.apiUrl + '/get_transfer_list', params);
	},
	// 订单详情
	orderDetail: (params) => {
		return request.post(config.api.apiUrl + '/order_detail', params);
	},
	// 确认收货
	sureOrder: (params) => {
		return request.post(config.api.apiUrl + '/sure_order', params);
	},
	// 获取用户邀请码
	getUserInviteCode: (params) => {
		return request.bgPost(config.api.apiUrl + '/get_user_invite_code', params);
	},
	// 平台规则
	getPlatformRules: (params) => {
		return request.post(config.api.apiUrl + '/get_platform_rules', params);
	},
	// 购买套餐
	suitOrder: (params) => {
		return request.post(config.api.apiUrl + '/suit_order', params);
	},
	// 微信支付
	wxPay: (params) => {
		return request.post(config.api.apiUrl + '/hwc/pay/mini_pay', params);
	},

	// 测试支付
	testPay: (params) => {
		return request.post(config.api.apiUrl + '/hwc/pay/wx_h5', params);
	},

	// 删除订单
	deleteOrder: (params) => {
		return request.bgPost(config.api.apiUrl + '/delete_order', params);
	},
	// 修改密码
	changePassword: (params) => {
		return request.bgPost(config.api.apiUrl + '/change_password', params);
	},
	// 修改支付密码
	changePayPassword: (params) => {
		return request.bgPost(config.api.apiUrl + '/change_pay_password', params);
	},
	// 修改头像
	intUpdateUserAvatar: (file, type) => {
		return request.postFile(config.api.uploadUrl + '?type=' + type, file);
	},
	// 修改用户名称
	updateNickName: (params) => {
		return request.bgPost(config.api.apiUrl + '/update_nick_name', params);
	},
	// 数元图标
	valueChart: (params) => {
		return request.post(config.api.apiUrl + '/value_chart', params, false);
	},
	// 验证码
	mobileCode: (params) => {
		return request.post(config.api.serviceUrl + '/mobile_code', params, false);
	},
	// 用户验证码
	userMobileCode: (params) => {
		return request.post(config.api.apiUrl + '/mobile_code', params);
	},
	// 忘记密码
	forgotPassword: (params) => {
		return request.post(config.api.apiUrl + '/forgot_password', params, false);
	},
	// 编辑地址
	editUserAddress: (params) => {
		return request.post(config.api.apiUrl + '/edit_user_address', params);
	},
	// 设置默认地址
	setDefaultAddress: (params) => {
		return request.post(config.api.apiUrl + '/set_default_address', params);
	},
	// 获取发行量信息
	totalMathemeValue: (params) => {
		return request.post(config.api.apiUrl + '/total_wes_value', params);
	},
	// 用户提现
	userWithdrawal: (params) => {
		return request.post(config.api.apiUrl + '/user_withdrawal', params);
	},
	// 用户提现记录
	userWithdrawalLog: (params) => {
		return request.post(config.api.apiUrl + '/user_withdrawal_log', params);
	},
	// 金元类型
	jinYuanType: (params) => {
		return request.bgPost(config.api.apiUrl + '/jin_yuan_type', params);
	},
	// 金元日志
	jinYuanLog: (params) => {
		return request.bgPost(config.api.apiUrl + '/jin_yuan_log', params);
	},
	// 获取上一次提现信息
	getWithdrawalInfo: (params) => {
		return request.bgPost(config.api.apiUrl + '/get_withdrawal_info', params);
	},
	// pos机列表
	getposlist: (params) => {
		return request.post(config.api.apiUrl + '/user_pos_list', params);
	},
	//pos 添加
	addpos: (params) => {
		return request.post(config.api.apiUrl + '/user_binding_pos', params);
	},
	//升级券列表
	getGradelist: (params) => {
		return request.post(config.api.apiUrl + '/get_upgrade_volumes', params);
	},
	//升级券升级
	getGradesub: (params) => {
		return request.post(config.api.apiUrl + '/user_upgrade', params);
	},
	//升级规则
	getGradeguize: (params) => {
		return request.post(config.api.apiUrl + '/get_binding_rules', params);
	},
	// 转出数元
	transferOutDmt: (params) => {
		return request.post(config.api.apiUrl + '/transfer_out_dmt', params);
	},
	// 使用算力提升卷
	shiyongslj: (params) => {
		return request.post(config.api.apiUrl + '/use_promote_volumes', params);
	},
	// 获取权限升级信息
	getRelease: (params) => {
		return request.post(config.api.apiUrl + '/get_promote_release', params);
	},
	// 会员升级下单
	// buyUpgrade: (params) => {
	// 	return request.post(config.api.apiUrl + '/buy_upgrade', params)
	// },
	// 释放权益升级下单
	buyPrmote: (params) => {
		return request.post(config.api.apiUrl + '/buy_promote', params);
	},
	// 修改银行卡信息
	userBankInfo: (params) => {
		return request.post(config.api.apiUrl + '/modify_user_bank_info', params);
	},
	// 修改微信支付账号
	userWechatAccount: (params) => {
		return request.post(config.api.apiUrl + '/modify_user_wechat_account', params);
	},
	// 修改支付宝账号
	userAlipayAccount: (params) => {
		return request.post(config.api.apiUrl + '/modify_user_alipay_account', params);
	},
	// 上传图片
	uploadPic: (file, type, opt) => {
		return request.postFile(config.api.uploadUrl + '/imag' + '?type=' + type, file, opt);
	},
	// 佣金提现
	commissionWithdraw: (params) => {
		return request.post(config.api.apiUrl + '/commission_withdraw', params);
	},
	// 佣金提现明细
	getCommissionWithdrawLogs: (params) => {
		return request.post(config.api.apiUrl + '/get_commission_withdraw_logs', params);
	},
	// 佣金明细
	getCommissionLogs: (params) => {
		return request.post(config.api.apiUrl + '/get_commission_logs', params);
	},
	// 收款方式
	userReceiptInfo: (params) => {
		return request.post(config.api.apiUrl + '/user_receipt_info', params);
	},
	// 微信支付宝上传二维码
	updateAccountCode: (file, type) => {
		return request.postFile(config.api.apiUrl + '/update_account_code' + '?type=' + type, file);
	},

	// 商家详情
	getShopInfo: (params) => {
		return request.post(config.api.apiUrl + '/get_shop_info', params);
	},
	// 商家商品列表
	getShopGoods: (params) => {
		return request.post(config.api.apiUrl + '/get_shop_goods', params);
	},
	// 商品商家列表
	getShopListByGoods: (params) => {
		return request.post(config.api.apiUrl + '/get_shop_list_by_goods', params);
	},
	// 商家导航轮播图
	getAdListByShop: (params) => {
		return request.post(config.api.apiUrl + '/get_ad_list_by_shop', params);
	},
	// 公告列表
	getNoticeList: (params) => {
		return request.post(config.api.apiUrl + '/get_notice_list', params);
	},
	// 公告详情
	details: (params) => {
		return request.post(config.api.apiUrl + '/details', params);
	},
	// 代金券
	// 收款方式
	voucherMealList: (params) => {
		return request.get(config.api.apiUrl + '/voucher_meal_list', params);
	},
	// 充值创建订单
	userBuyVoucherMeal: (params) => {
		return request.post(config.api.apiUrl + '/user_buy_voucher_meal', params);
	},
	// 抵扣券充值记录
	userVoucherOrders: (params) => {
		return request.get(config.api.apiUrl + '/user_voucher_orders', params);
	},
	// 抵扣券充值记录
	getVoucherLogs: (params) => {
		return request.get(config.api.apiUrl + '/get_voucher_logs', params);
	},
	// 签到
	userSign: (params) => {
		return request.post(config.api.apiUrl + '/user_sign', params);
	},
	// 判断用户是否签到
	userIsSign: (params) => {
		return request.get(config.api.apiUrl + '/user_is_sign', params);
	},
	// 订单滚动弹窗
	getRollOrder: (params) => {
		return request.bgGET(config.api.apiUrl + '/get_roll_order', params);
	},
	// 获取关注状态
	dealUserSubscribeInfo: (params) => {
		return request.bgPost(config.api.apiUrl + '/deal_user_subscribe_info', params);
	},
	// 微信分享配置
	weChatShareConfig: (params) => {
		return request.bgPost(config.api.serviceUrl + '/wechat_share_config', params);
	},
	// 待分红记录
	getDaifenhongLogs: (params) => {
		return request.get(config.api.apiUrl + '/daifenhong_log', params);
	},
	// 宣传视频
	viewVideo: (params) => {
		return request.get(config.api.apiUrl + '/view_video', params);
	},
	//拼团列表
	groupPurchaseList: (params) => {
		return request.get(config.api.apiUrl + '/get_list', params);
	},
	//拼团商品详情
	groupPurchaseGoodDetail: (params) => {
		return request.get(config.api.apiUrl + '/get_details', params);
	},
	//获取代金券金额
	getAllowance: (params) => {
		return request.get(config.api.apiUrl + '/getAllowance', params);
	},
	//拼团保证金验证是否已交
	verificationPrice: (params) => {
		return request.post(config.api.apiUrl + '/VerificationPrice', params);
	},
	//创建拼团订单
	createGroupPurchaseOrder: (params) => {
		return request.post(config.api.apiUrl + '/create_order', params);
	},
	//拼团订单列表
	getGroupPurchaseOrderList: (params) => {
		return request.get(config.api.apiUrl + '/getOrderList', params);
	},
	//代金券记录
	getAllowanceLog: (params) => {
		return request.get(config.api.apiUrl + '/getAllowanceLog', params);
	},
	//发布求购
	wantToBuy: (params) => {
		return request.post(config.api.apiUrl + '/wantToBuy', params);
	},
	//我的求购
	myWantToBuy: (params) => {
		return request.get(config.api.apiUrl + '/myWantToBuy', params);
	},
	//求购中/已完成
	getKcList: (params) => {
		return request.get(config.api.apiUrl + '/getKcList', params);
	},
	//出售WES
	sellWes: (params) => {
		return request.post(config.api.apiUrl + '/sell', params);
	},
	//暂停WES订单
	suspendWes: (params) => {
		return request.post(config.api.apiUrl + '/suspend', params);
	},
	//WES交易订单
	myBuySellWes: (params) => {
		return request.get(config.api.apiUrl + '/myBuySell', params);
	},
	//兑换中心统计
	getCount: (params) => {
		return request.get(config.api.apiUrl + '/getCount', params);
	},
	//购物金记录
	priceList: (params) => {
		return request.get(config.api.apiUrl + '/priceList', params);
	},
	//代金券记录
	allowance: (params) => {
		return request.get(config.api.apiUrl + '/allowance', params);
	},
	//WES通证
	wesLog: (params) => {
		return request.get(config.api.apiUrl + '/wesLog', params);
	},
	//拼团通证记录
	getWesHList: (params) => {
		return request.get(config.api.apiUrl + '/getWesHList', params);
	},
	//获取首页分页（新）
	getCategorize: (params) => {
		return request.get(config.api.apiUrl + '/getCategorize', params);
	},
	//获取分类下商品（新）
	getGoodsByCateId: (params) => {
		return request.get(config.api.apiUrl + '/getGoods', params);
	},
	//购物佣金充值配置
	priceCofig: (params) => {
		return request.get(config.api.apiUrl + '/priceCofig', params);
	},
	//购物佣金充值支付
	hwcWeChatH5Shop: (params) => {
		return request.post(config.api.apiUrl + '/hwc_we_chat_h5_shop', params);
	},
	//购物佣金充值记录
	getCommission: (params) => {
		return request.get(config.api.apiUrl + '/getCommission', params);
	},
	//保证金列表
	getDeposit: (params) => {
		return request.get(config.api.apiUrl + '/getDeposit', params);
	},
	//保证金转入
	depositTransferIn: (params) => {
		return request.post(config.api.apiUrl + '/transferCommissionToDeposit', params);
	},
	//场次
	getSessions: (params) => {
		return request.get(config.api.apiUrl + '/getSessions', params);
	},
	//通证分红转入
	dividendsTransIn: (params) => {
		return request.post(config.api.apiUrl + '/dividends', params);
	},
	//通证分红转出
	dividendsTransOut: (params) => {
		return request.post(config.api.apiUrl + '/TransferOut', params);
	},
	//获取分红转入转出手续费配置
	getTransConfig: () => {
		return request.get(config.api.apiUrl + '/getConfig');
	}
};